export default __webpack_public_path__ + "34ef4f83f0bfc77052e5890f250bf5d0.svg";